import React from 'react'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'

function Footer() {
	return (
		<div>
			<footer className='space--sm footer-1 text-center-xs'>
				<div className='container'>
					<div className='row'>
						<div className='col-md-3 col-6'>
							<h4>Orders</h4>
							<ul className=''>
								<li>
									<a href='/about-us/contact-us'>
										Contact Us
									</a>
								</li>
								<li>
									<a href='/shipping-and-returns'>
										<span>Shipping &amp; Returns</span>
									</a>
								</li>
							</ul>
						</div>
						<div className='col-md-3 col-6'>
							<h4>Information</h4>
							<ul>
								<li>
									<a href='/as-seen-in'>
										<span>As Seen In</span>
									</a>
								</li>
								<li>
									<a href='/brand-directory'>
										<span>Brands</span>
									</a>
								</li>
								<li>
									<a href='/ethical-glossary'>
										<span>Ethical Glossary</span>
									</a>
								</li>
								<li>
									<a href='/ethical-production-standards'>
										<span>
											Ethical Production Standards
										</span>
									</a>
								</li>
								<li>
									<a href='/about-us/faqs'>FAQs</a>
								</li>
								<li>
									<a href='/about-us/our-team'>Our Team</a>
								</li>
								<li>
									<a href='/about-us/our-story'>Our Story</a>
								</li>
								<li>
									<a href='/about-us/our-process'>
										Our Process
									</a>
								</li>
								<li>
									<a href='/privacy-policy'>
										<span>Privacy Policy</span>
									</a>
								</li>
								<li>
									<a href='/terms-of-use'>
										<span>Terms of Use</span>
									</a>
								</li>
							</ul>
						</div>
						<div className='col-md-3 col-6'>
							<h4>For Sellers</h4>
							<ul>
								<li>
									<a href='/login/seller'>
										<span>Seller Login</span>
									</a>
								</li>
								<li>
									<a href='/sell-with-us'>
										<span>Sell With Us</span>
									</a>
								</li>
								<li>
									<a href='/seller-expectations'>
										Seller Expectations
									</a>
								</li>
								<li>
									<a href='/category'>Wholesale</a>
								</li>
							</ul>
						</div>
						<div className='col-md-3 col-12'>
							<h4 className=''>
								Sign Up for early access <br />
								&amp; special offers
							</h4>
							<form action='#' method='post'>
								<div className='row align-items-end'>
									<div className='form-group  col-12'>
										<input
											type='email'
											name='newsletterEmail'
											id='newsletterEmail'
											placeholder='Your Email'
										/>
									</div>
									<div className='form-group col-12'>
										<button type='submit' className='btn'>
											<span className='btn__text'>
												Sign Up
											</span>
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
					<div className='row'>
						<div className='col-md-6'>
							<img
								alt='The Etho Word Logo'
								className='logo'
								src='https://ignitedlocal.s3.us-east-2.amazonaws.com/The+Etho/TheEthoVisualLogo.png'
							/>
							<span className='type--fine-print'>
								©<span className='update-year'>2019</span> The
								Etho
							</span>
						</div>
						<div className='col-md-6 text-right'>
							<ul className='social-list list-inline'>
								<li>
									<a
										href='https://twitter.com/shoptheetho?lang=en'
										target='_blank'
										rel='noopener noreferrer'>
										<FAI icon={['fab', 'twitter']} />
									</a>
								</li>
								<li>
									<a
										href='https://www.facebook.com/shoptheetho/'
										target='_blank'
										rel='noopener noreferrer'>
										<FAI icon={['fab', 'facebook-f']} />
									</a>
								</li>
								<li>
									<a
										href='https://www.instagram.com/shoptheetho/'
										target='_blank'
										rel='noopener noreferrer'>
										<FAI icon={['fab', 'instagram']} />
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</footer>
		</div>
	)
}

export default Footer
